import findKey from 'lodash/findKey'
import fromPairs from 'lodash/fromPairs'
import { UPLOAD_FILE_TYPES } from '@klear/upload/file-types'
export const BINARY_CONTENT_TYPE = 'application/octet-stream'
export const PDF_CONTENT_TYPE = 'application/pdf'

const CONTENT_TYPE_BY_EXTENSION: Record<string, string> = fromPairs(
  UPLOAD_FILE_TYPES.flatMap((type) => type.extensions.map((extension) => [extension, type.contentType]))
)

export function storageKeyExtension(key: string): string {
  const lastSegment = key.split('/').pop() ?? ''
  if (!lastSegment.includes('.')) return ''
  return (lastSegment.split('.').pop() ?? '').toLowerCase()
}

export function contentTypeForStorageKey(key: string): string {
  return CONTENT_TYPE_BY_EXTENSION[storageKeyExtension(key)] ?? BINARY_CONTENT_TYPE
}

export function filenameForContentType(name: string, contentType: string): string {
  if (contentTypeForStorageKey(name) === contentType) return name
  const extension = findKey(CONTENT_TYPE_BY_EXTENSION, (type) => type === contentType)
  return extension === undefined ? name : `${name}.${extension}`
}

export function resolveStoredContentType(reported: string | undefined, key: string): string {
  if (reported != null && reported !== '' && reported !== BINARY_CONTENT_TYPE && reported !== 'binary/octet-stream') {
    return reported
  }
  return contentTypeForStorageKey(key)
}

const PREVIEWABLE_TYPES = UPLOAD_FILE_TYPES.filter((type) => type.readable)

const MCP_IMAGE_CONTENT_TYPES: ReadonlySet<string> = new Set(
  PREVIEWABLE_TYPES.filter((type) => type.contentType.startsWith('image/')).map((type) => type.contentType)
)

export function isModelRenderableImageContentType(contentType: string): boolean {
  return MCP_IMAGE_CONTENT_TYPES.has(contentType)
}

const PREVIEWABLE_CONTENT_TYPES: ReadonlySet<string> = new Set(PREVIEWABLE_TYPES.map((type) => type.contentType))

export const NOT_PREVIEWABLE_MESSAGE = "Can't be previewed, download it instead"

export function isPreviewableContentType(contentType: string): boolean {
  return PREVIEWABLE_CONTENT_TYPES.has(contentType)
}

export function isPreviewableFilename(name: string): boolean {
  return isPreviewableContentType(contentTypeForStorageKey(name))
}
